<template>
  <div id="personSignature" class="wrap-Main">
    <div class="box-S4 flex-between-center">
      <div class="N-Page">
        <div class>
          <span class="T-size-24"
            >แบบสำแดงยืนยันปฏิบัติตามนโยบายด้านสิ่งเสพติดและแอลกอฮอล์</span
          >
        </div>
      </div>
      <!-- <v-icon
        style="font-size: 30px"
        v-show="CheckIn == 1"
        @click="PrintDecareForm()"
        >mdi-printer</v-icon> -->
    </div>

    <div class="box-S4">
      <div class="B-carddetail B-formMain">
        <div class="b-condition">
          <div class="box-S4">
            <div class="b-checkbox checkin">
              <p>
                1)
                ท่านมีสารหรือสิ่งเสพติดต้องห้ามดังต่อไปนี้ในสัมภาระหรือพกพาที่ต้องสำแดงหรือไม่?<br />&nbsp;&nbsp;Do
                you have any of the following substances in your possession or
                in baggage to declare?
              </p>
              <div class="table-responsive">
                <table>
                  <thead>
                    <tr>
                      <th style="width: 35%" colspan="2">
                        "สารหรือสิ่งเสพติดต้องห้าม
                      </th>
                      <th style="width: 40%" colspan="1">
                        Prohibited drugs / substances
                      </th>
                      <th style="width: 25%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>กัญชา, กระท่อม, กัญชง</td>
                      <td>Marijuana, Cannabis, Kratom, Hemp</td>
                      <td colspan="2">
                        <v-radio-group
                          v-model="accept1"
                          row
                          :disabled="CheckIn == 1"
                        >
                          <v-radio label="มี Yes" value="true"></v-radio>
                          <v-radio label="ไม่มี No" value="false"></v-radio>
                        </v-radio-group>
                      </td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>โคเคน ฝิ่น เฮโรอีน</td>
                      <td>Cocaine, Opiates, Heroine,</td>
                      <td colspan="2">
                        <v-radio-group
                          v-model="accept2"
                          row
                          :disabled="CheckIn == 1"
                        >
                          <v-radio label="มี Yes" value="true"></v-radio>
                          <v-radio label="ไม่มี No" value="false"></v-radio>
                        </v-radio-group>
                      </td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>มอร์ฟีน ยาบ้า</td>
                      <td>Morphine, Amphetamine,</td>
                      <td colspan="2">
                        <v-radio-group
                          v-model="accept3"
                          row
                          :disabled="CheckIn == 1"
                        >
                          <v-radio label="มี Yes" value="true"></v-radio>
                          <v-radio label="ไม่มี No" value="false"></v-radio>
                        </v-radio-group>
                      </td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>ยาอี ยาไอซ์</td>
                      <td>Ecstasy, Methylenedioxyamphetamine</td>
                      <td colspan="2">
                        <v-radio-group
                          v-model="accept4"
                          row
                          :disabled="CheckIn == 1"
                        >
                          <v-radio label="มี Yes" value="true"></v-radio>
                          <v-radio label="ไม่มี No" value="false"></v-radio>
                        </v-radio-group>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="5">
                        ** หากท่านมีคำถามหรือข้อสงสัยเกี่ยวกับสิ่งที่พกมาด้วย
                        เช่น ยารักษาโรคหรืออาหารเสริม
                        กรุณาสำแดงและสอบถามติดต่อเจ้าหน้าที่<br />If you have
                        any medicines or food supplements on you and in doubts,
                        please declare and contact check-in staff.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <br />

              <p>
                2)
                ท่านได้นำของเหลวหรือเครื่องดื่มดังต่อไปนี้ติดในสัมภาระหรือพกพาที่ต้องสำแดงหรือไม่<br />&nbsp;&nbsp;Do
                you have any of the following alcohol beverages on you or in
                baggage to declare?
              </p>
              <table>
                <thead>
                  <tr>
                    <th style="width: 35%" colspan="2">
                      "เครื่องดื่มที่มีส่วนผสมแอลกอฮอล์
                    </th>
                    <th style="width: 40%" colspan="1">
                      Prohibited Alcohol Mixed/Based Beverages
                    </th>
                    <th style="width: 25%"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>วิสกี้, ไวน์, บรั่นดี, รัม</td>
                    <td>Whiskey, wine, brandy, rum</td>
                    <td colspan="2">
                      <v-radio-group
                        v-model="accept5"
                        row
                        :disabled="CheckIn == 1"
                      >
                        <v-radio label="มี Yes" value="true"></v-radio>
                        <v-radio label="ไม่มี No" value="false"></v-radio>
                      </v-radio-group>
                    </td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>สาโท, อุ, กะแช่</td>
                    <td>Malt, booze, liquor</td>
                    <td colspan="2">
                      <v-radio-group
                        v-model="accept6"
                        row
                        :disabled="CheckIn == 1"
                      >
                        <v-radio label="มี Yes" value="true"></v-radio>
                        <v-radio label="ไม่มี No" value="false"></v-radio>
                      </v-radio-group>
                    </td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>เบียร์, เบียร์ 0% แอลกอฮอล์, สาเก</td>
                    <td>Beers, 0% alcohol beer, sake</td>
                    <td colspan="2">
                      <v-radio-group
                        v-model="accept7"
                        row
                        :disabled="CheckIn == 1"
                      >
                        <v-radio label="มี Yes" value="true"></v-radio>
                        <v-radio label="ไม่มี No" value="false"></v-radio>
                      </v-radio-group>
                    </td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>ไวน์คูลเลอร์, เครื่องดื่มหมักยีสต์ทุกประเภท</td>
                    <td>Wine Cooler, any alcohol content beverages</td>
                    <td colspan="2">
                      <v-radio-group
                        v-model="accept8"
                        row
                        :disabled="CheckIn == 1"
                      >
                        <v-radio label="มี Yes" value="true"></v-radio>
                        <v-radio label="ไม่มี No" value="false"></v-radio>
                      </v-radio-group>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5">
                      ** หากท่านมีคำถามหรือข้อสงสัยเกี่ยวกับสิ่งที่พกมาด้วย เช่น
                      ยารักษาโรคหรืออาหารเสริม
                      กรุณาสำแดงและสอบถามติดต่อเจ้าหน้าที่<br />If you have any
                      medicines or food supplements on you and in doubts, please
                      declare and contact check-in staff.
                    </td>
                  </tr>
                </tbody>
              </table>

              <p>รายการที่สำแดง (ถ้ามี) Declared items (if any)</p>

              <v-row>
                <v-col cols="12" sm="3" md="3">
                  <v-checkbox
                    :disabled="CheckIn == 1"
                    v-model="medicine1"
                    label="ยาสามัญ"
                    value="true"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    :disabled="CheckIn == 1"
                    v-model="medicine5"
                    label="ยาเบาหวาน"
                    value="true"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    :disabled="CheckIn == 1"
                    v-model="medicine9"
                    label="ยาแก้แพ้"
                    value="true"
                    hide-details
                  ></v-checkbox>
                </v-col>

                <v-col cols="12" sm="3" md="3">
                  <v-checkbox
                    :disabled="CheckIn == 1"
                    v-model="medicine2"
                    label="พาราเซตามอล"
                    value="true"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    :disabled="CheckIn == 1"
                    v-model="medicine6"
                    label="วิตามิน"
                    value="true"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    :disabled="CheckIn == 1"
                    v-model="medicine10"
                    label="ยาเมาเรือ"
                    value="true"
                    hide-details
                  ></v-checkbox>
                </v-col>

                <v-col cols="12" sm="3" md="3">
                  <v-checkbox
                    :disabled="CheckIn == 1"
                    v-model="medicine3"
                    label="ยาความดัน"
                    value="true "
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    :disabled="CheckIn == 1"
                    v-model="medicine7"
                    label="อาหารเสริม"
                    value="true "
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    :disabled="CheckIn == 1"
                    v-model="medicine11"
                    label="ยาแก้ปวดเมื่อย"
                    value="true "
                    hide-details
                  ></v-checkbox>
                </v-col>

                <v-col cols="12" sm="3" md="3">
                  <v-checkbox
                    :disabled="CheckIn == 1"
                    v-model="medicine4"
                    label="ยาโรคเก๊าท์"
                    value="true"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    :disabled="CheckIn == 1"
                    v-model="medicine8"
                    label="ฟ้าทะลายโจร"
                    value="true"
                    hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="d-flex justify">
                  <v-checkbox
                    :disabled="CheckIn == 1"
                    @click="IsOtherDeclaredItem()"
                    v-model="other"
                    label="อื่นๆ"
                    value="true"
                    hide-details
                  ></v-checkbox>
                  <v-text-field
                    :disabled="CheckIn == 1"
                    v-if="other"
                    label="โปรดระบุ"
                    v-model="otherDetail"
                    @blur="UpdateDecareForm()"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row align="center"> </v-row>

              <v-checkbox
                :disabled="CheckIn == 1"
                @click="UpdateDecareForm()"
                v-model="consent"
                value="consented"
                hide-details
                label="ข้าพเจ้ายินดีปฏิบัติตามนโยบายของบริษัท และขอยืนยันว่าข้อมูลที่สำแดงตามแบบสอบถามข้างบนเป็นจริงทุกประการ I acknowledge the Company’s Drugs and Alcohol Policy and hereby declare and confirm all answers are correct and true."
              ></v-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="line"></div>
  </div>
</template>

<script>
import { latLng, icon } from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LIconDefault,
  LPolyline,
  LIcon,
  LPopup,
} from "vue2-leaflet";
import {
  startOfDay,
  endOfDay,
  format,
  addHours,
  addMinutes,
  differenceInMinutes,
} from "date-fns";
import feathersClientUOA from "../../plugins/feathers-client-uoa";
import feathersClientVan from "../../plugins/feathers-client";
import Vue2LeafletRotatedMarker from "vue2-leaflet-rotatedmarker";
// import fillerdate from "../utils/filterdate";

export default {
  name: "Example",
  components: {},
  data() {
    return {
      declareID: "",
      accept1: "",
      accept2: "",
      accept3: "",
      accept4: "",
      accept5: "",
      accept6: "",
      accept7: "",
      accept8: "",

      medicine1: "",
      medicine2: "",
      medicine3: "",
      medicine4: "",
      medicine5: "",
      medicine6: "",
      medicine7: "",
      medicine8: "",
      medicine9: "",
      medicine10: "",
      medicine11: "",
      other: "",
      otherDetail: "",

      consent: "",
      createdate: null,
    };
  },
  //Edit true false
  props: [
    "PassengerID",
    "Fullname",
    "CompanyName",
    "Destination",
    "CheckIn",
    "CheckInDateTime",
    "SignatureImage",
  ],
  async mounted() {
    await feathersClientUOA.service("declare-form").on("patched", (declare) => {
      this.DataDecareFromDB();
    });

    try {
      var q = {};
      q.p_id = this.PassengerID;
      var resFind = await feathersClientUOA
        .service("decare-form")
        .find({ query: q });
      if (resFind.total == 0) {
        //Create New
        let dataAdd = {
          p_id: this.PassengerID,
          dc_accept1: "",
          dc_accept2: "",
          dc_accept3: "",
          dc_accept4: "",
          dc_accept5: "",
          dc_accept6: "",
          dc_accept7: "",
          dc_accept8: "",
          dc_medicine1: "",
          dc_medicine2: "",
          dc_medicine3: "",
          dc_medicine4: "",
          dc_medicine5: "",
          dc_medicine6: "",
          dc_medicine7: "",
          dc_medicine8: "",
          dc_medicine9: "",
          dc_medicine10: "",
          dc_medicine11: "",
          dc_other: "",
          dc_other_detail: "",
          dc_consent: "",
          dc_createdate: new Date(),
        };

        var resCreate = await feathersClientUOA
          .service("decare-form")
          .create(dataAdd);

        this.declareID = resCreate.dc_id;
      } else {
        this.declareID = resFind.data[0].dc_id;
        this.DataDecareFromDB();
      }
    } catch (error) {
      console.log(error);
    }
  },
  async destroyed() {
    await this.UpdateDecareForm();
  },
  methods: {
    async DataDecareFromDB() {
      var q = {};
      q.dc_id = this.declareID;
      var resFind = await feathersClientUOA
        .service("decare-form")
        .find({ query: q });
      this.accept1 = resFind.data[0].dc_accept1;
      this.accept2 = resFind.data[0].dc_accept2;
      this.accept3 = resFind.data[0].dc_accept3;
      this.accept4 = resFind.data[0].dc_accept4;
      this.accept5 = resFind.data[0].dc_accept5;
      this.accept6 = resFind.data[0].dc_accept6;
      this.accept7 = resFind.data[0].dc_accept7;
      this.accept8 = resFind.data[0].dc_accept8;
      this.medicine1 = resFind.data[0].dc_medicine1;
      this.medicine2 = resFind.data[0].dc_medicine2;
      this.medicine3 = resFind.data[0].dc_medicine3;
      this.medicine4 = resFind.data[0].dc_medicine4;
      this.medicine5 = resFind.data[0].dc_medicine5;
      this.medicine6 = resFind.data[0].dc_medicine6;
      this.medicine7 = resFind.data[0].dc_medicine7;
      this.medicine8 = resFind.data[0].dc_medicine8;
      this.medicine9 = resFind.data[0].dc_medicine9;
      this.medicine10 = resFind.data[0].dc_medicine10;
      this.medicine11 = resFind.data[0].dc_medicine11;
      this.other = resFind.data[0].dc_other;
      this.otherDetail = resFind.data[0].dc_other_detail;
      this.consent = resFind.data[0].dc_consent;
    },
    async UpdateDecareForm() {
      try {
        if (this.consent == null) {
          this.consent = "";
        }

        let dataUpdate = {
          dc_accept1: this.accept1,
          dc_accept2: this.accept2,
          dc_accept3: this.accept3,
          dc_accept4: this.accept4,
          dc_accept5: this.accept5,
          dc_accept6: this.accept6,
          dc_accept7: this.accept7,
          dc_accept8: this.accept8,
          dc_medicine1: this.medicine1,
          dc_medicine2: this.medicine2,
          dc_medicine3: this.medicine3,
          dc_medicine4: this.medicine4,
          dc_medicine5: this.medicine5,
          dc_medicine6: this.medicine6,
          dc_medicine7: this.medicine7,
          dc_medicine8: this.medicine8,
          dc_medicine9: this.medicine9,
          dc_medicine10: this.medicine10,
          dc_medicine11: this.medicine11,
          dc_other: this.other,
          dc_other_detail: this.otherDetail,
          dc_consent: this.consent,
          dc_createdate: new Date(),
        };

        var res = await feathersClientUOA
          .service("decare-form")
          .patch(this.declareID, dataUpdate);
      } catch (error) {
        console.log(error);
      }
    },

    IsOtherDeclaredItem() {
      if (this.other) {
        this.otherDeclaredItem = "";
      }
    },
    // async PrintDecareForm() {
    //   let medicines = "";
    //   if (this.medicine1) {
    //     medicines += "ยาสามัญ ";
    //   }
    //   if (this.medicine2) {
    //     medicines += "พาราเซตามอล ";
    //   }
    //   if (this.medicine3) {
    //     medicines += "ยาความดัน ";
    //   }
    //   if (this.medicine4) {
    //     medicines += "ยาโรคเก๊าท์ ";
    //   }
    //   if (this.medicine5) {
    //     medicines += "ยาเบาหวาน ";
    //   }
    //   if (this.medicine6) {
    //     medicines += "วิตามิน ";
    //   }
    //   if (this.medicine7) {
    //     medicines += "อาหารเสริม ";
    //   }
    //   if (this.medicine8) {
    //     medicines += "ฟ้าทะลายโจร ";
    //   }
    //   if (this.medicine9) {
    //     medicines += "ยาแก้แพ้ ";
    //   }
    //   if (this.medicine10) {
    //     medicines += "ยาเมาเรือ ";
    //   }
    //   if (this.medicine11) {
    //     medicines += "ยาแก้ปวดเมื่อย ";
    //   }
    //   if (this.other) {
    //     medicines += this.otherDetail;
    //   }

    //   var customerlogo = await this.$LogoService.GetLogoBaseurl64(4);

    //   var pdfMake = require("../../public/js/pdfmake");
    //   if (pdfMake.vfs == undefined) {
    //     var pdfFonts = require("../../public/js/vfs_fonts");
    //     pdfMake.vfs = pdfFonts.pdfMake.vfs;
    //   }
    //   pdfMake.fonts = {
    //     THSarabunNew: {
    //       normal: "THSarabunNew.ttf",
    //       bold: "THSarabunNew-Bold.ttf",
    //       italics: "THSarabunNew-Italic.ttf",
    //       bolditalics: "THSarabunNew-BoldItalic.ttf",
    //     },
    //     Roboto: {
    //       normal: "Roboto-Regular.ttf",
    //       bold: "Roboto-Medium.ttf",
    //       italics: "Roboto-Italic.ttf",
    //       bolditalics: "Roboto-MediumItalic.ttf",
    //     },
    //     Fontello: {
    //       normal: "fontello.ttf",
    //       bold: "fontello.ttf",
    //       italics: "fontello.ttf",
    //       bolditalics: "fontello.ttf",
    //     },
    //   };
    //   var docDefinitionyComplianceDeclarationForm = {
    //     images: {
    //       signatureImage: this.SignatureImage,
    //     },
    //     content: [
    //       {
    //         style: "tableExample",
    //         table: {
    //           widths: ["auto", "auto", "*"],
    //           body: [
    //             [
    //               {
    //                 width: 122 * 0.4,
    //                 height: 74 * 0.4,
    //                 alignment: "left",
    //                 image:
    //                   "data:image/png;base64,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",
    //               },
    //               {
    //                 text: "",
    //               },
    //               {
    //                 width: customerlogo.w * 2.32,
    //                 height: customerlogo.h * 2.32,
    //                 alignment: "right",
    //                 margin: [15, 0, 0, 0],
    //                 image: customerlogo.logo,
    //               },
    //             ],
    //             ["", "", ""],
    //           ],
    //         },
    //         layout: "headerLineOnly",
    //       },
    //       {
    //         style: "tableHeader",
    //         table: {
    //           widths: ["*", "auto", "*"],
    //           body: [
    //             [
    //               {
    //                 text: "",
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "แบบสำแดงยืนยันปฏิบัติตามนโยบายด้านสิ่งเสพติดและแอลกอฮอล์",
    //                 fontSize: 14,
    //                 bold: true,
    //                 margin: [0, 0, 0, 0],
    //                 alignment: "center",
    //               },
    //               {
    //                 text: "",
    //                 alignment: "right",
    //               },
    //             ],
    //             [
    //               {
    //                 text: "",
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "Drugs & Alcohol Policy Compliance Declaration Form",
    //                 fontSize: 14,
    //                 bold: true,
    //                 margin: [0, 0, 0, 0],
    //                 alignment: "center",
    //               },
    //               {
    //                 text: "",
    //                 alignment: "right",
    //               },
    //             ],
    //           ],
    //         },
    //         layout: "headerLineOnly",
    //       },
    //       {
    //         style: "tableTransportMode",
    //         table: {
    //           headerRows: 1,
    //           widths: ["*", "auto", "auto"],
    //           body: [
    //             [
    //               {
    //                 text: "",
    //                 border: [false, false, false, false],
    //               },
    //               {
    //                 image:
    //                   "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QzA2MEU3NzY5RjVDMTFFQzlCMDU5REY3NTlERTQ4QkIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QzA2MEU3Nzc5RjVDMTFFQzlCMDU5REY3NTlERTQ4QkIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpDMDYwRTc3NDlGNUMxMUVDOUIwNTlERjc1OURFNDhCQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpDMDYwRTc3NTlGNUMxMUVDOUIwNTlERjc1OURFNDhCQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PreteusAAABpSURBVHjaYvz//z8DLQETA40BzS1gAAURDAOBBxA/BgmTiUF6PVDMRLPgEQWGw/AjZDMZkSOZkZHxP9RXjOSEBjb9Qz+SRy0YtWDUglELiAAsaHxQeS4LKxXJBI/pWuEwjlb6hABAgAEAF698FDGkuJwAAAAASUVORK5CYII=",
    //                 width: 13,
    //                 alignment: "right",
    //                 border: [false, false, false, false],
    //               },
    //               {
    //                 text: "HQ",
    //                 alignment: "left",
    //                 border: [false, false, false, false],
    //               },
    //             ],
    //           ],
    //         },
    //       },
    //       {
    //         style: "tableInformation",
    //         table: {
    //           headerRows: 1,
    //           widths: ["auto", "*", "*", "auto", "*"],
    //           body: [
    //             [
    //               {
    //                 text: "ชื่อ-นามสกุล\r\nFull name:",
    //                 fontSize: 12,
    //                 bold: true,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: this.Fullname,
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 2,
    //               },
    //               {
    //                 text: "",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "ชื่อบริษัท\r\nCompany name:",
    //                 fontSize: 12,
    //                 bold: true,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: this.CompanyName,
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //             ],
    //             [
    //               {
    //                 text: "ปลายทาง\r\nDestination:",
    //                 fontSize: 12,
    //                 bold: true,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: this.Destination,
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 2,
    //               },
    //               {
    //                 text: "",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "เดินทางโดย\r\nTransport Mode:",
    //                 fontSize: 12,
    //                 bold: true,
    //                 alignment: "left",
    //               },
    //               {
    //                 table: {
    //                   headerRows: 1,
    //                   widths: ["auto", "auto", "auto", "auto"],
    //                   body: [
    //                     [
    //                       {
    //                         image:
    //                           "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAAdklEQVQ4y2NgGLTAg+Exw3888DFQBQp4hFc5CD5C1QASwgcw5KmoQYc0DVEMfxjqiNcAUv6foYZYDQjleDRoYlWOU0Mdw2+GECzKcWpoAZK/GUIxlONxUjNYC7pyvJ5uBrNrSIm4JgzltE0aOORJTt4kZ6BBBAADNZmOfmKY6QAAAABJRU5ErkJggg==",
    //                         width: 13,
    //                         alignment: "right",
    //                         border: [false, false, false, false],
    //                       },

    //                       {
    //                         text: "Helicopter",
    //                         fontSize: 12,
    //                         alignment: "left",
    //                         border: [false, false, false, false],
    //                       },
    //                       {
    //                         image:
    //                           "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QzA2MEU3NzY5RjVDMTFFQzlCMDU5REY3NTlERTQ4QkIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QzA2MEU3Nzc5RjVDMTFFQzlCMDU5REY3NTlERTQ4QkIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpDMDYwRTc3NDlGNUMxMUVDOUIwNTlERjc1OURFNDhCQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpDMDYwRTc3NTlGNUMxMUVDOUIwNTlERjc1OURFNDhCQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PreteusAAABpSURBVHjaYvz//z8DLQETA40BzS1gAAURDAOBBxA/BgmTiUF6PVDMRLPgEQWGw/AjZDMZkSOZkZHxP9RXjOSEBjb9Qz+SRy0YtWDUglELiAAsaHxQeS4LKxXJBI/pWuEwjlb6hABAgAEAF698FDGkuJwAAAAASUVORK5CYII=",
    //                         width: 13,
    //                         alignment: "right",
    //                         border: [false, false, false, false],
    //                       },
    //                       {
    //                         text: "Boat",
    //                         border: [false, false, false, false],
    //                       },
    //                     ],
    //                   ],
    //                 },
    //               },
    //             ],
    //           ],
    //         },
    //       },
    //       /*Start ProhibitedDrugs*/
    //       {
    //         style: "tableTitleProhibitedDrugs",
    //         table: {
    //           headerRows: 1,
    //           widths: ["*"],
    //           body: [
    //             [
    //               {
    //                 text: "1) ท่านมีสารหรือสิ่งเสพติดต้องห้ามดังต่อไปนี้ในสัมภาระหรือพกพาที่ต้องสำแดงหรือไม่?\r\nDo you have any of the following substances in your possession or in baggage to declare? (ทำเครื่องหมาย Mark √)",
    //                 fontSize: 14,
    //                 border: [false, false, false, false],
    //                 alignment: "left",
    //               },
    //             ],
    //           ],
    //         },
    //       },
    //       {
    //         style: "tableProhibitedDrugs",
    //         table: {
    //           headerRows: 1,
    //           widths: ["*", "*", "*", "*", "*", "*", "*", "*", "*", "*"],
    //           body: [
    //             [
    //               {
    //                 text: "สารหรือสิ่งเสพติดต้องห้าม",
    //                 fontSize: 12,
    //                 bold: true,
    //                 alignment: "center",
    //                 colSpan: 4,
    //               },
    //               {
    //                 text: "2",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "3",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "4",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "Prohibited drugs / substances",
    //                 fontSize: 12,
    //                 bold: true,
    //                 alignment: "center",
    //                 colSpan: 4,
    //               },
    //               {
    //                 text: "6",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "7",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "8",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "มี\r\nYes",
    //                 fontSize: 12,
    //                 bold: true,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: "ไม่มี\nNo",
    //                 fontSize: 12,
    //                 bold: true,
    //                 alignment: "center",
    //               },
    //             ],
    //             [
    //               {
    //                 text: "1",
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: "กัญชา, กระท่อม, กัญชง",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 3,
    //               },
    //               {
    //                 text: "3",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "4",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "Marijuana, Cannabis, Kratom, Hemp",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 4,
    //               },
    //               {
    //                 text: "6",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "7",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "8",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: this.IsTrue(this.accept1),
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: this.IsFalse(this.accept1),
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //             ],
    //             [
    //               {
    //                 text: "2",
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: "โคเคน ฝิ่น เฮโรอีน",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 3,
    //               },
    //               {
    //                 text: "3",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "4",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "Cocaine, Opiates, Heroine",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 4,
    //               },
    //               {
    //                 text: "6",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "7",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "8",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: this.IsTrue(this.accept2),
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: this.IsFalse(this.accept2),
    //                 fontSize: 14,
    //                 alignment: "center",
    //               },
    //             ],
    //             [
    //               {
    //                 text: "3",
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: "มอร์ฟีน ยาบ้า",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 3,
    //               },
    //               {
    //                 text: "3",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "4",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "Morphine, Amphetamine",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 4,
    //               },
    //               {
    //                 text: "6",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "7",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "8",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: this.IsTrue(this.accept3),
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: this.IsFalse(this.accept3),
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //             ],
    //             [
    //               {
    //                 text: "4",
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: "ยาอี ยาไอซ์",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 3,
    //               },
    //               {
    //                 text: "3",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "4",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "Ecstasy, Methylenedioxyamphetamine",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 4,
    //               },
    //               {
    //                 text: "6",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "7",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "8",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: this.IsTrue(this.accept4),
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: this.IsFalse(this.accept4),
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //             ],
    //             [
    //               {
    //                 text: "** หากท่านมีคำถามหรือข้อสงสัยเกี่ยวกับสิ่งที่พกมาด้วย เช่น ยารักษาโรคหรืออาหารเสริม กรุณาสำแดงและสอบถามติดต่อเจ้าหน้าที่\r\nIf you have any medicines or food supplements on you and in doubts, please declare and contact check-in staff.",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 10,
    //               },
    //               {
    //                 text: "2",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 3,
    //               },
    //               {
    //                 text: "3",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "4",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "5",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 4,
    //               },
    //               {
    //                 text: "6",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "7",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "8",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "9",
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: "10",
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //             ],
    //           ],
    //         },
    //       },
    //       /*End ProhibitedDrugs */
    //       /*Start Alcohol_beverages */
    //       {
    //         style: "tableTitleProhibitedDrugs",
    //         table: {
    //           headerRows: 1,
    //           widths: ["*"],
    //           body: [
    //             [
    //               {
    //                 text: "\r\n",
    //                 fontSize: 0.5,
    //                 border: [false, false, false, false],
    //               },
    //             ],
    //             [
    //               {
    //                 text: "2) ท่านได้นำของเหลวหรือเครื่องดื่มดังต่อไปนี้ติดในสัมภาระหรือพกพาที่ต้องสำแดงหรือไม่\r\nDo you have any of the following alcohol beverages on you or in baggage to declare? (ทำเครื่องหมาย Mark √)",
    //                 fontSize: 14,
    //                 border: [false, false, false, false],
    //                 alignment: "left",
    //               },
    //             ],
    //           ],
    //         },
    //       },
    //       {
    //         style: "tableProhibitedDrugs",
    //         table: {
    //           headerRows: 1,
    //           widths: ["*", "*", "*", "*", "*", "*", "*", "*", "*", "*"],
    //           body: [
    //             [
    //               {
    //                 text: "เครื่องดื่มที่มีส่วนผสมแอลกอฮอล์",
    //                 fontSize: 12,
    //                 bold: true,
    //                 alignment: "center",
    //                 colSpan: 4,
    //               },
    //               {
    //                 text: "2",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "3",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "4",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "Prohibited Alcohol Mixed/Based Beverages",
    //                 fontSize: 12,
    //                 bold: true,
    //                 alignment: "center",
    //                 colSpan: 4,
    //               },
    //               {
    //                 text: "6",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "7",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "8",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "มี\r\nYes",
    //                 fontSize: 12,
    //                 bold: true,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: "ไม่มี\r\nNo",
    //                 fontSize: 12,
    //                 bold: true,
    //                 alignment: "center",
    //               },
    //             ],
    //             [
    //               {
    //                 text: "1",
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: "วิสกี้, ไวน์, บรั่นดี, รัม",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 3,
    //               },
    //               {
    //                 text: "3",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "4",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "Whiskey, wine, brandy, rum,",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 4,
    //               },
    //               {
    //                 text: "6",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "7",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "8",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: this.IsTrue(this.accept5),
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: this.IsFalse(this.accept5),
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //             ],
    //             [
    //               {
    //                 text: "2",
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: "สาโท, อุ, กะแช่",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 3,
    //               },
    //               {
    //                 text: "3",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "4",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "Malt, booze, liquor",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 4,
    //               },
    //               {
    //                 text: "6",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "7",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "8",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: this.IsTrue(this.accept6),
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: this.IsFalse(this.accept6),
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //             ],
    //             [
    //               {
    //                 text: "3",
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: "เบียร์, เบียร์ 0% แอลกอฮอล์, สาเก",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 3,
    //               },
    //               {
    //                 text: "3",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "4",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "Beers, 0% alcohol beer, sake",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 4,
    //               },
    //               {
    //                 text: "6",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "7",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "8",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: this.IsTrue(this.accept7),
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: this.IsFalse(this.accept7),
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //             ],
    //             [
    //               {
    //                 text: "4",
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: "ไวน์คูลเลอร์, เครื่องดื่มหมักยีสต์ทุกประเภท",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 3,
    //               },
    //               {
    //                 text: "3",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "4",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "Wine Cooler, any alcohol content beverages",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 4,
    //               },
    //               {
    //                 text: "6",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "7",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "8",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: this.IsTrue(this.accept8),
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: this.IsFalse(this.accept8),
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //             ],
    //             [
    //               {
    //                 text: "** หากท่านมีคำถามหรือข้อสงสัยเกี่ยวกับสิ่งที่พกมาด้วย เช่น ยารักษาโรคหรืออาหารเสริม กรุณาสำแดงและสอบถามติดต่อเจ้าหน้าที่\r\nIf you have any medicines or food supplements on you and in doubts, please declare and contact check-in staff.",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 10,
    //               },
    //               {
    //                 text: "2",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 3,
    //               },
    //               {
    //                 text: "3",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "4",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "5",
    //                 fontSize: 12,
    //                 alignment: "left",
    //                 colSpan: 4,
    //               },
    //               {
    //                 text: "6",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "7",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "8",
    //                 fontSize: 12,
    //                 alignment: "left",
    //               },
    //               {
    //                 text: "9",
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //               {
    //                 text: "10",
    //                 fontSize: 12,
    //                 alignment: "center",
    //               },
    //             ],
    //             [
    //               {
    //                 text: "",
    //                 fontSize: 0.5,
    //                 alignment: "center",
    //                 colSpan: 10,
    //                 border: [false, false, false, false],
    //               },
    //               {
    //                 text: "",
    //               },
    //               {
    //                 text: "",
    //               },
    //               {
    //                 text: "",
    //               },
    //               {
    //                 text: "",
    //               },
    //               {
    //                 text: "",
    //               },
    //               {
    //                 text: "",
    //               },
    //               {
    //                 text: "",
    //               },
    //               {
    //                 text: "",
    //               },
    //               {
    //                 text: "",
    //               },
    //             ],
    //           ],
    //         },
    //       },
    //       /*End Alcohol_beverages  */
    //       {
    //         style: "tableDeclaredItems",
    //         table: {
    //           headerRows: 1,
    //           widths: ["auto", "*"],
    //           body: [
    //             [
    //               {
    //                 text: "รายการที่สำแดง (ถ้ามี)\r\n Declared items (if any)",
    //                 fontSize: 12,
    //               },
    //               {
    //                 text: medicines,
    //                 fontSize: 12,
    //               },
    //             ],
    //             [
    //               {
    //                 text: "",
    //                 fontSize: 0.5,
    //                 border: [false, false, false, false],
    //                 colSpan: 2,
    //               },
    //             ],
    //           ],
    //         },
    //       },
    //       {
    //         style: "tableSignature",
    //         table: {
    //           headerRows: 1,
    //           widths: ["*", "*", "*"],
    //           body: [
    //             [
    //               {
    //                 text: "ข้าพเจ้ายินดีปฏิบัติตามนโยบายของบริษัท และขอยืนยันว่าข้อมูลที่สำแดงตามแบบสอบถามข้างบนเป็นจริงทุกประการ\r\nI acknowledge the Company’s Drugs and Alcohol Policy and hereby declare and confirm all answers are correct and true.",
    //                 alignment: "left",
    //                 colSpan: 3,
    //                 fontSize: 12,
    //               },
    //               {
    //                 text: "",
    //               },
    //               {
    //                 text: "",
    //               },
    //             ],
    //             [
    //               {
    //                 text: "ลงลายมือชื่อ\r\nSignature:",
    //                 alignment: "left",
    //                 fontSize: 12,
    //               },
    //               {
    //                 image: "signatureImage",
    //                 width: 80,
    //                 alignment: "center",
    //               },
    //               {
    //                 text:
    //                   "วันที่ Date: " +
    //                   format(new Date(this.CheckInDateTime), "dd/MM/yyy HH:mm"),
    //                 fontSize: 12,
    //               },
    //             ],
    //           ],
    //         },
    //       },
    //       { text: "INTERNAL", color: "red", size: 50 },
    //     ],
    //     styles: {},
    //     defaultStyle: {
    //       font: "THSarabunNew",
    //     },
    //   };
    //   pdfMake
    //     .createPdf(docDefinitionyComplianceDeclarationForm)
    //     .download("ComplianceDeclarationForm.pdf");
    // },

    IsTrue(choice) {
      if (choice == "true") {
        return "√";
      }
    },
    IsFalse(choice) {
      if (choice == "false") {
        return "√";
      }
    },
  },
};
</script>

<style scoped>
table.center {
  margin-left: auto;
  margin-right: auto;
}

th {
  height: 50px;
}

td {
  height: 50px;
  vertical-align: top;
}

table {
  width: 100%;
}
</style>